import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DISCOUNT_MULTI_NEW_ITEM_FOR_MULTI_QUERY } from "./schema";

export const useDiscountMultiNewItemForMultiQuery = (hotelID: string, duplicateDiscountId?: string) => {
	const { data } = useCustomSuspenseQuery(DISCOUNT_MULTI_NEW_ITEM_FOR_MULTI_QUERY, {
		variables: { hotelID, duplicateDiscountId, discountListHotelId2: hotelID },
		fetchPolicy: "no-cache",
	});

	return {
		discountMultiNewItemForMultiServerModel: data,
	};
};
